var _g, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpCon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_4994_2391)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.64411 6.96016L17.2821 2.27884C18.9438 1.47174 20.8846 1.47508 22.5435 2.28788L32.1611 7.00022C33.7967 7.8016 34.9797 9.30252 35.3768 11.08L37.6929 21.4475C38.0887 23.2191 37.6612 25.0746 36.5301 26.4943L29.9622 34.7386C28.8238 36.1676 27.0963 37 25.2693 37H14.5532C12.7305 37 11.0066 36.1715 9.86799 34.7482L3.26541 26.4949C2.12951 25.0751 1.69879 23.2167 2.09423 21.4419L4.40915 11.0523C4.80708 9.26637 5.99822 7.75959 7.64411 6.96016Z",
    fill: "#E3211B"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.64411 6.96016L17.2821 2.27884C18.9438 1.47174 20.8846 1.47508 22.5435 2.28788L32.1611 7.00022C33.7967 7.8016 34.9797 9.30252 35.3768 11.08L37.6929 21.4475C38.0887 23.2191 37.6612 25.0746 36.5301 26.4943L29.9622 34.7386C28.8238 36.1676 27.0963 37 25.2693 37H14.5532C12.7305 37 11.0066 36.1715 9.86799 34.7482L3.26541 26.4949C2.12951 25.0751 1.69879 23.2167 2.09423 21.4419L4.40915 11.0523C4.80708 9.26637 5.99822 7.75959 7.64411 6.96016Z",
    stroke: "#FFC427",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4018 17.3535L17.0622 20.2317L17.8335 16.3695L19.758 15.8176L18.4593 21.2438L22.382 24.9689L20.323 25.5593L17.7205 22.8829L16.8913 26.5433L14.9669 27.0951L16.3466 21.9516L12.3428 17.9439L14.4018 17.3535ZM26.1039 21.0179L24.5966 21.4501L25.3607 24.1147L23.5035 24.6473L20.8795 15.4961L24.2439 14.5313C26.4151 13.9088 27.8042 14.6561 28.4114 16.7735C28.7175 17.8411 28.6748 18.7418 28.2832 19.4755C27.898 20.1976 27.1715 20.7118 26.1039 21.0179ZM24.1413 19.8621L25.6351 19.4338C26.5592 19.1688 26.8566 18.4621 26.5273 17.3137C26.3652 16.7485 26.1373 16.3769 25.8435 16.199C25.5472 16.0121 25.1613 15.9868 24.6858 16.1232L23.192 16.5515L24.1413 19.8621Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_4994_2391",
    x: 0.450195,
    y: 0.175888,
    width: 38.8867,
    height: 38.3241,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4994_2391"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpCon);
export default __webpack_public_path__ + "static/media/exp-con.d63eacaaf8dd41ba03c2e23c2b4f3d90.svg";
export { ForwardRef as ReactComponent };